import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'provision-controller-dialog',
  templateUrl: 'provision.controller.dialog.html',
})

export class ProvisionControllerDialogComponent {
  controllerId = null;
  parkId = null;
  url = null;
  provisioningInProgress = false;
  files = [];

  constructor(public dialogRef: MatDialogRef<ProvisionControllerDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
              private http: HttpClient) {
    this.controllerId = data.controllerId;
    this.parkId = data.parkId;
    this.url = data.url;
  }

  private completeProvisioning() {
    this.provisioningInProgress = false;
    this.dialogRef.disableClose = false;
  }

  formatSize(file: { size: number }) {
    if (file.size < 1000) {
      return file.size + 'B';
    } else if (file.size < 1000000) {
      return (file.size / 1000).toFixed(2) + 'kB';
    } else {
      return (file.size / 1000000).toFixed(2) + 'MB';
    }
  }

  onCloseCancel() {
    this.dialogRef.close();
  }

  startProvisioning() {
    this.provisioningInProgress = true;
    this.dialogRef.disableClose = true;

    const body = {
      files: this.files,
    };

    this.http.post(this.url, body).subscribe(() => {
      this.completeProvisioning();

      this.dialogRef.close({success: true, message: 'Provisioning started. This may take a few minutes'});
    }, (err) => {
      this.completeProvisioning();
      console.log(err);
    });
  }

  handleFiles(event) {
    if (event.target.files && event.target.files.length > 0) {
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files.item(i);
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = () => {
          this.files.push({
            name: file.name,
            content: reader.result,
            size: file.size
          });
        };
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/controller/provision.controller.dialog.component.ts